/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSetAnswerReactionWebRequest,
  TSetAnswerReactionWebModel,
  IMappers,
  TSetAnswerReactionWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISetAnswerReactionWebResponse } from '../../entities/set_answer_reaction/SetAnswerReactionWebResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSetAnswerReactionWebModel(parameters: TSetAnswerReactionWebRequest): TSetAnswerReactionWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-reviews',
    pathApi: '/v1/set-answer-reaction-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISetAnswerReactionWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSetAnswerReactionWebRequest;
}

export async function fetchSetAnswerReactionWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetAnswerReactionWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSetAnswerReactionWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSetAnswerReactionWebModel(parameters),
    config,
  )) as FetchResponse<TSetAnswerReactionWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetAnswerReactionWebResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSetAnswerReactionWebResponse>;
}
